var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '@emotion/styled';
import { useLocalization } from '../../common/providers/LocaleProvider';
import co2_de from '../../common/assets/images/footer/de_CO2.svg';
import co2_fr from '../../common/assets/images/footer/fr_CO2.svg';
import co2_en from '../../common/assets/images/footer/en_CO2.svg';
import swiss_online_garantie from '../../common/assets/images/footer/swiss_online_garantie.svg';
import thuiswinkel_waarborg from '../../common/assets/images/footer/thuiswinkel_waarborg.svg';
/* tslint:disable variable-name */
var trusted_co2_de = {
    image: {
        src: co2_de,
        alt: 'h24_footer_co2_icon_alt',
        width: 108,
        height: 42,
    },
    link: {
        href: 'h24_footer_co2_icon_url',
        target: '_blank',
        rel: 'noopener',
    },
    Content: null,
};
var trusted_co2_fr = {
    image: {
        src: co2_fr,
        alt: 'h24_footer_co2_icon_alt',
        width: 108,
        height: 42,
    },
    link: {
        href: 'h24_footer_co2_icon_url',
        target: '_blank',
        rel: 'noopener',
    },
    Content: null,
};
var trusted_co2_en = {
    image: {
        src: co2_en,
        alt: 'h24_footer_co2_icon_alt',
        width: 108,
        height: 42,
    },
    link: {
        href: 'h24_footer_co2_icon_url',
        target: '_blank',
        rel: 'noopener',
    },
    Content: null,
};
var ekomi_de_fr = {
    image: {
        src: 'h24_footer_ekomi_icon_src',
        width: 48,
        height: 48,
    },
    link: {
        href: 'h24_footer_ekomi_icon_url',
        target: '_blank',
        rel: 'noopener',
    },
    Content: function () {
        var l10n = useLocalization();
        return l10n.replace.t('h24_footer_ekomi_icon_text', {
            h24_footer_ekomi_average: l10n.t('h24_footer_ekomi_average'),
            h24_footer_ekomi_ratings: l10n.t('h24_footer_ekomi_ratings'),
        });
    },
};
var swiss_online_de_fr = {
    image: {
        src: swiss_online_garantie,
        alt: 'h24_swiss_online_trusted_icons_alt',
        width: 48,
        height: 48,
    },
    link: {
        href: 'h24_swiss_online_trusted_icons_url',
        target: '_blank',
        rel: 'noopener',
    },
    Content: function () {
        var l10n = useLocalization();
        return (React.createElement("div", { dangerouslySetInnerHTML: {
                __html: l10n.t('h24_swiss_online_trusted_icons_text'),
            } }));
    },
};
var StyledListBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & ul {\n    position: relative;\n    list-style: none;\n    margin: 0;\n    margin-left: 20px;\n    padding: 0;\n  }\n\n  & li:before {\n    content: '\u2713';\n    left: -16px;\n    position: absolute;\n    color: #048d0e;\n  }\n"], ["\n  & ul {\n    position: relative;\n    list-style: none;\n    margin: 0;\n    margin-left: 20px;\n    padding: 0;\n  }\n\n  & li:before {\n    content: '\u2713';\n    left: -16px;\n    position: absolute;\n    color: #048d0e;\n  }\n"])));
var thuiswinkel_nl = {
    image: {
        src: thuiswinkel_waarborg,
        alt: 'h24_thuiswinkle_trusted_icons_alt',
        width: 48,
        height: 48,
    },
    link: {
        href: 'h24_thuiswinkle_trusted_icons_url',
        target: '_blank',
        rel: 'noopener',
    },
    Content: function () {
        var l10n = useLocalization();
        return (React.createElement(StyledListBox, { dangerouslySetInnerHTML: {
                __html: l10n.t('h24_thuiswinkle_trusted_icons_text'),
            } }));
    },
};
var de_DE_h24 = [trusted_co2_de, ekomi_de_fr];
var de_DE_ffh = [trusted_co2_de];
var de_AT = [trusted_co2_de, ekomi_de_fr];
var de_CH = [trusted_co2_de, swiss_online_de_fr];
var fr_BE = [trusted_co2_fr];
var fr_CH = [trusted_co2_fr, swiss_online_de_fr];
var fr_FR = [trusted_co2_fr, ekomi_de_fr];
var it_IT = [trusted_co2_en];
var nl_BE = [trusted_co2_en];
var nl_NL = [trusted_co2_en, thuiswinkel_nl];
/* tslint:enable variable-name */
export default {
    de_DE_h24: de_DE_h24,
    de_DE_ffh: de_DE_ffh,
    de_AT: de_AT,
    de_CH: de_CH,
    fr_BE: fr_BE,
    fr_CH: fr_CH,
    fr_FR: fr_FR,
    it_IT: it_IT,
    nl_BE: nl_BE,
    nl_NL: nl_NL,
};
var templateObject_1;
